const scrollToChunk = chunk => {
  return (dispatch, getState) => {
    // const { userScroll } = getState().ScrollState;
    const { activeChunk } = getState().ChunkState;
    const c = activeChunk;
    const currentChunk = document.getElementById(`chunk-${c}`);
    let isFirstChunk = parseInt(c.split('.').pop(), 10) === 1;
    const position = currentChunk ? currentChunk.offsetTop : 0;
    let adjustment = 50;

    if (!window.userScrolled) {
      window.scroll({
        top: isFirstChunk ? 0 : position + adjustment,
        behavior: 'smooth'
      });
    }
  };
};

const setAndScroll = chunk => {
  return dispatch => {
    dispatch({
      type: 'SET_ACTIVE_CHUNK',
      activeChunk: chunk
    });
    dispatch(scrollToChunk(chunk));
  };
};

const lastChunkLoaded = () => {
  return dispatch => {
    setTimeout(() => {
      dispatch(scrollToChunk());
    }, 999);
  };
};

export { setAndScroll, lastChunkLoaded, scrollToChunk };
